import { ConsentManagerOptions } from "@c15t/react"
import { CURRENT_REGION } from "lib/environment"
import { buildTranslations } from "cookiesConsent/infrastructure/c15t/config/translations"
import {
  CONSENT_CATEGORIES,
  buildPolicyPacks
} from "cookiesConsent/infrastructure/c15t/config/policyPacks"

const legalHref = `/pages/privacy/`

export const options = {
  mode: `offline`,
  consentCategories: CONSENT_CATEGORIES,
  store: { reloadOnConsentRevoked: false },
  storageConfig: { storageKey: `wb-consent` },
  legalLinks: {
    privacyPolicy: { href: legalHref, target: `_self` },
    cookiePolicy: { href: legalHref, target: `_self` }
  },
  i18n: {
    locale: `en`,
    detectBrowserLanguage: false,
    messages: {
      en: buildTranslations(CURRENT_REGION)
    }
  },
  theme: {
    colors: {
      primary: `hsl(0, 0%, 0%)`,
      primaryHover: `hsl(0, 0%, 15%)`,
      textOnPrimary: `hsl(0, 0%, 100%)`
    },
    radius: {
      sm: `0`,
      md: `0`,
      lg: `0`,
      full: `0`
    },
    typography: {
      fontFamily: `minion-pro, serif`
    },
    consentActions: {
      accept: { variant: `primary`, mode: `filled` },
      reject: { variant: `neutral`, mode: `stroke` },
      customize: { variant: `neutral`, mode: `ghost` }
    },
    slots: {
      consentBanner: { className: `wb-c15t-banner` },
      consentBannerCard: { className: `wb-c15t-banner-card` },
      consentBannerTitle: { className: `wb-c15t-banner-title` },
      consentBannerDescription: { className: `wb-c15t-banner-description` }
    }
  },
  offlinePolicy: {
    policyPacks: buildPolicyPacks()
  }
} satisfies ConsentManagerOptions
